<template>

<com-item name="players.games" :is-cards="true" :size="size" :empty-cards="empty" :has-more="data.total > 5" v-on:more="onMoreClick" :is-empty="!active" :loading="loading" title="Widely Played">

	<template v-slot:about>

		<p>Games played most with the widest range of people.</p>

	</template>

	<template v-slot:stats>

		<com-card :item="item" v-for="item in data.games" :key="item.g" :id="item.g" :name="$store.getters['data/games/associated'][item.g].name">

            <core-card-foot-stat :value="item.players" text="player" :plural="true" />

            <core-card-foot-date :value="item.d" text="last play" />

            <core-card-foot-stat :value="item.plays" text="play" :plural="true" />

        </com-card>

	</template>

</com-item>

</template>

<script>

import comItem from './../common/Item'
import comCard from './../common/Card'

export default {

	props: ['fetching', 'you', 'your', 'size'],

	components: {
		'com-item': comItem,
		'com-card': comCard
	},

	computed: {

		loading: function() {

			return this.fetching === 'all'

		},

		data: function() {

			return this.$store.getters['page/insights/players/games']

		},

		empty: function() {

			var empty = []

			for (var i = this.data.games.length; i < 5; i++) {

				empty.push(true)

			}

			return empty.length

		},

		active: function() {

			return this.data.games.length && !this.loading

		}

	},

	methods: {

		onMoreClick: function() {

			this.$pubsub.$emit('panel.open', {
				type: 'insightsPlayersGames'
			})

		}

	}

}

</script>

<style scoped>

</style>